<template>
  <div class="user-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="form.companyName"
            placeholder="请输入公司名称"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="$router.push('add')"
            v-hasPermi="['公司管理', '新增']"
            >新增公司</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="公司名称"
          width="230"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="contact" label="公司联系人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="联系人电话" align="center">
        </el-table-column>
        <el-table-column
          prop="address"
          label="公司地址"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="company_code_name"
          label="公司性质"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="parent_comp_name"
          label="所属公司"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                v-if="scope.row.company_code != 4"
                @click="viewClick(scope.row.company_id, scope.row.company_code)"
                v-hasPermi="['公司管理', '详情']"
                >查看</span
              >
              <span
                class="btn read"
                @click="deleteCompanyclick(scope.row.company_id)"
                v-hasPermi="['公司管理', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompanyList, deleteCompany, detailCompany } from '@/api/company'
import { MessageBox } from 'element-ui'
export default {
  data () {
    return {
      form: {
        companyName: '',
        type: ''
      },
      loading: false,
      options: [
        { id: '', name: '全部' }
      ],
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      }
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
  },
  methods: {
    deleteCompanyclick (id) {
      MessageBox.confirm('此操作将删除该公司, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteCompanyes(id)
      }).catch(() => {
        //this.$message('已取消删除')      
      });
    },
    deleteCompanyes (id) {
      deleteCompany({ id }).then(res => {
        if (res.code === 0) {
          this.$message.success('删除成功!')
          this.getData()
        }
      })
    },
    getData () {
      this.loading = true
      const params = { companyName: this.form.companyName, start: this.table.currentPage, size: this.table.size }
      getCompanyList(params).then(res => {
        this.loading = false
        const data = res.data
        this.table.data = data.content
        this.table.total = data.total
        this.$refs.tables.bodyWrapper.scrollTop = 0;
      })
    },
    viewClick (id, company_code) {
      this.$router.push({ name: 'editComp', query: { id, company_code } })
    },
    search () {
      this.table.currentPage = 1
      this.getData()
    },
    currentChange () {
      this.getData()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.user-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.equipment-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
